import React, { useEffect } from "react";
import CloseIcon from '@mui/icons-material/Close';
import { analysis, calenderIcon, editicongreen, humangrey, noteedit, orders, sethescope, todayorder } from "./svgs";

import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const OrderHistoryModal = ({ isOpen, onClose ,orderdetails, selectedAppointment, apphis,data}) => {

const navigate=useNavigate()
const start = selectedAppointment?.startdate;
 if (!isOpen) return null;
  return (
<div className="fixed inset-0 z-50 flex items-start justify-center bg-black bg-opacity-50 overflow-y-auto">
  <div className="bg-white w-[90%] max-w-lg rounded-md shadow-lg relative mt-10 mb-10">
        {/* Modal Header */}
        <div className="flex items-center justify-between px-6 py-3 border-b border-[#E5E7EB] bg-white shadow-sm">
          {/* Left side: Calendar icon + Date block + Edit button */}
          <div className="flex items-center gap-2">
            {/* Icon + Date stacked vertically */}
            <div className="flex items-center gap-2">
              <span>{calenderIcon}</span>
              <div className="flex flex-col text-xs font-medium">
  <span className="text-black text-sm">
    {dayjs(start).format("dddd")} {/* 👉 Wednesday */}
  </span>
  <span className="text-gray-800">
    {dayjs(start).format("MM/DD/YYYY")} {/* 👉 09/02/2025 */}
  </span>
</div>

            </div>

            {/* Edit button */}
            <button
             onClick={() => {
                         
                           navigate(`/orders/${data.appointmentid}/${data.startdate}/all`)
                          }
                        }
              className="rounded-[8.5px] border px-3 py-1 text-sm flex items-center gap-1"
              style={{ color: "rgba(0, 186, 124, 1)", borderColor: "rgba(0, 186, 124, 1)" }}
            >
              {editicongreen} Edit Order
            </button>
          </div>

          {/* Right side: Close button */}
          <button
            onClick={() => onClose(false)}
            className="text-gray-400 hover:text-gray-600"
          >
            <CloseIcon style={{ width: 20, height: 20 }} />
          </button>
        </div>

        {/* Modal Body */}
        <div className="">
          <div className="w-full flex flex-col gap-4 px-4 justify-center items-center">

            {/* Patient Info */}
            <div className="w-full flex gap-2 border border-[rgba(80, 134, 154, 0.20)] rounded-lg p-6 mt-6">
      <div class="w-16 h-16 rounded-full border-4 border-white overflow-hidden bg-gray-300 shadow-md">
  <img 
    src={`/cloud-assets/chim/public/assets/images/profilepictures/${data.patientid}.png`} 
    onError={(e) => e.target.src = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAOEAAADhCAMAAAAJbSJIAAAAM1BMVEXk5ueutLeqsbTn6eqpr7PJzc/j5ebf4eLZ3N2wtrnBxsjN0NLGysy6v8HT1tissra8wMNxTKO9AAAFDklEQVR4nO2d3XqDIAxAlfivoO//tEOZWzvbVTEpic252W3PF0gAIcsyRVEURVEURVEURVEURVEURVEURVEURVEURVEURflgAFL/AirAqzXO9R7XNBVcy9TbuMHmxjN6lr92cNVVLKEurVfK/zCORVvW8iUBnC02dj+Wpu0z0Y6QlaN5phcwZqjkOkK5HZyPAjkIjSO4fIdfcOwFKkJlX4zPu7Ha1tIcwR3wWxyFhRG6g4Je0YpSPDJCV8a2Sv2zd1O1x/2WMDZCwljH+clRrHfWCLGK8REMiql//2si5+DKWKcWeAGcFMzzNrXC/0TUwQ2s6+LhlcwjTMlYsUIQzPOCb7YBiyHopyLXIEKPEkI/TgeuiidK/R9FniUDOjRDpvm0RhqjMyyXNjDhCfIMYl1gGjIMIuYsnGEYRMRZOMMunaLVwpWRW008v6fYKDIzxCwVAeNSO90BJW6emelYBRF/kHpYGVaoxTDAaxOFsfP9y8hpJ4xd7gOcij7JNGQ1EYFgkPJa1jQEiYZXRaRINKxSDUW9n+FT82lSKadkiru9/4XPqSLWOekGPoY05TAvLm9orm+YWuwHoBHkZKijNBJGmeb61eL6Ff/6q7bLr7yvv3vKGhpDRjvgjGaPz+gUg6YgcvpyAR2FIZ9U6nEEyZRTovmEU32KichpGn7C17XrfyH9gK/c0CMP05HZIM2uf9sEveizKveBy9/6Qt7o89ne33D525cfcIMW6ab+TMEukQbQbu+xu7X3A9bChmWaCeAkG17bpntwXgWxHaMzGPmUaR5dQZiKqRVeUZ3047fi3nAu28h4CHxCsZAgmEH8Y27jJAhm8c+5RQzRQNVGhVFSfxOYIjp/pP7RxzjevYXVGf4eLt+BJ1vCuLuLkrgABgCGXZ2wik5uty+oBvNirI6mkzhAf4Gsb58Hcm67Jzd+KwD10BYPLL3e0MjvKrgAULnOfveF/O4N2Xb9BZom3gJes3F9X5Zze8/6Yt09b4CrqsEjUv8oFBaR2rl+6CZr2xVrp24o/WitBKuGrrpl1+bFkmK2qXTON4VpbdfLa7o7y/WdLxG7lm2Lqh2clOwTegbvc/vj2U78CwhA87Bn8G5Nk3eOb0Nsr9flz3sG78UUtue4kpv1xvjg3TMay62BMlTlP+vrOMnJsRmt/ze0jsfkPPYdAH57hK+34PeOyc8XIXu5xT2HsUkdZz+adwg8HGFfQ3K5jtDvbUiO4Di9/ywHGrL88pDizZ++oTp+an+SMX/ndymUCwmHMdO7yuOx83pUx/eEMU0AvxWndwgidAqOZ8ypCwdEfvvEo6D9HwpA8wzvmOJEqAg9ySu8g4x0Hb9hSB/BANEKJ+LbPBU0lzbAJs4xt1AoshKkUGQmiH8/jJ0gdhTTLmSegHlPE0oOdXALnqDjKYh3px//fSgSWG8UqfrrIICzYYSJXRr9BSPbpNzw7gBjKjKOYI7ReIGqQRIap5+5MdjyvuDkExvGeXSlONWZAP3/AZBwJohU7QJRGU+cTVH18ELmRPNBmibW6MT/k1b0XhdkRBvyT6SB6EYv/GvhSmRNpGngRULsAlxMCGNXp7w3FfdEbTEEDdLI9TdIKRUzUesa3I461ER8cpNT7gMRhpKmYVS9ELOgCUQsa4SsulciKiLbY+AnHD8cpuhISsnxpamI84sbDq9qYJgf8wiiOBrC7Ml7M7ZECCqKoiiKoiiKoiiKoijv5AvJxlZRyNWWLwAAAABJRU5ErkJggg=='}
    alt="Profile Picture"
    class="w-full h-full object-cover block"
  />
</div>
              <div className="flex flex-col flex-1 gap-4">
                <div className="flex gap-3 items-center">
                  <div
                    style={{ color: "rgba(106, 114, 130, 1)", background: "rgba(80, 134, 154, 0.10)", border: "1.5px solid rgba(80, 134, 154, 0.30)" }}
                    className="rounded-full px-2 text-xs"
                  >
                    #{data?.patientid}
                  </div>
         <div className="text-sm font-bold text-start">
  {data?.firstname} {data?.lastname}
</div>

                  <div className="bg-[#F3E8FF] text-xs border-2 border-[#E9D4FF] rounded-full px-2 text-[#8200DB]">{data?.purpose}</div>
                </div>

                <div className="flex gap-4 text-start">
                  <div className="flex justify-center gap-2 items-center">
                    <div>{humangrey}</div>
                    <div>
                      <div className="text-[#6A7282] text-xs">Insurance</div>
                      <div className="text-[#101828] font-semibold text-sm">{data?.
insurancename}</div>
                    </div>
                  </div>
                  <div className="flex justify-center gap-2 items-center">
                    <div>{sethescope}</div>
                    <div>
                      <div className="text-[#6A7282] text-xs">Analysis</div>
                      <div className="text-[#101828] font-semibold text-sm">{data?.
linked_provider
                      }</div>
                    </div>
                  </div>
                  <div className="flex justify-center gap-2 items-center">
                    <div>{analysis}</div>
                    <div>
                      <div className="text-[#6A7282] text-xs">Level</div>
                      <div className="text-[#101828] font-semibold text-sm">4</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Orders Button */}
            <div className="w-full flex justify-center items-center bg-[#F1F5F9] rounded-full text-sm gap-2 px-4 py-2">
              {orders} Orders
            </div>

            <div className="w-full">
  <div className="border rounded-lg overflow-hidden">
    {/* Header */}
    <div
      style={{ background: "rgba(80, 134, 154, 0.05)" }}
      className="flex items-center gap-2 px-4 py-3 border-b"
    >
      <span className="text-[#6A7282]">{todayorder}</span>
      <span className="text-[#6A7282] font-inter font-normal text-sm">Today's Orders</span>
    </div>

    {/* Content */}
    <div className="p-3 flex flex-col gap-3 max-h-40 overflow-y-auto custom-scrollbar">
      {Array.isArray(apphis?.notes) && apphis.notes.length > 0 ? (
        apphis.notes.map((item, idx) => (
          <div
            key={idx}
            className="bg-[#6A7282] text-white rounded-xl px-3 py-3 flex items-center justify-between"
          >
            <div className="flex flex-col">
              <span className="text-[14px] font-inter text-[#fff] font-semibold">{item.ordername}</span>
              <span className="text-xs font-inter text-[#FFFFFF]">{item.ordertype}</span>
            </div>
            <div
              className={`text-xs px-2 py-1 rounded-full bg-[#FFFFFF4D] border border-[#FFFFFF4D] ${
                item.color ? item.color : "bg-gray-600"
              }`}
            >
              {item.status}
            </div>
          </div>
        ))
      ) : (
        <div className="text-sm text-gray-400 px-2">No orders available</div>
      )}
    </div>
  </div>
</div>

            {/* Scheduled Orders */}
        <div className="w-full">
  <div className="border rounded-xl overflow-hidden">
    <div
      style={{ background: "rgba(80, 134, 154, 0.05)" }}
      className="flex items-center gap-2 px-4 py-3 border-b"
    >
      <span className="text-[#6A7282]">{todayorder}</span>
      <span className="text-[#6A7282] font-inter font-normal text-sm">Scheduled Orders</span>
    </div>

    {/* Cards instead of rows */}
 <div className="flex flex-col text-start gap-3 p-3 max-h-60 overflow-y-auto">
  {Array.isArray(apphis?.notessch) && apphis.notessch.length > 0 ? (
    apphis.notessch.map((item, idx) => (
      <div
        key={idx}
        className="flex items-center justify-between px-2.5 py-2.5 rounded-[10.5px] border border-[#E5E7EB]"
      >
        <div>
          <div className="text-sm font-medium font-inter text-[#101828]">{item.ordername
}</div>
          <div className="text-xs font-inter font-normal text-[#4A5565]">{item.ordertype}</div>
        </div>
        <div
          className={`text-xs px-2 py-1 rounded-full border ${item.color}`}
        >
          {item.status}
        </div>
      </div>
    ))
  ) : (
    <div className="text-sm text-gray-400">No notes available</div>
  )}
</div>

  </div>
</div>


            {/* Notes */}
           <div className="w-full mb-4">
  <div className="border rounded-xl overflow-hidden">
    <div className="flex items-center gap-2 px-3 py-3">
      <span className="text-[#6A7282]">{noteedit}</span>
      <span className="text-[#6A7282] font-inter font-normal text-sm">Notes</span>
    </div>

    {/* scroll area */}
    <div className="px-3 pt-2 pb-3 max-h-52 overflow-y-auto space-y-2">
      {orderdetails?.notes?.length > 0 ? (
        orderdetails.notes.map((note, index) => (
          <div
            key={index}
            className="bg-[#F0FDF4] border border-[#BEDBFF] text-[#364153] text-xs text-left rounded-lg p-3"
          >
            {note?.ordername || "-"}
          </div>
        ))
      ) : (
        <div className="bg-[#F0FDF4] border border-[#BEDBFF] text-[#364153] text-xs rounded-lg p-3">
          -No Notes Available-
        </div>
      )}
    </div>
  </div>
</div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryModal;
